<template>
  <div class="mb-1 animate-pulse space-y-3 px-3 py-3">
    <div v-for="index in 8" :key="index" class="flex items-center justify-between">
      <div class="bg-neutral-99 h-8 w-full rounded-md" />
    </div>
  </div>
</template>

<script lang="ts" setup></script>
